import { useState } from 'react';

import ButtonWithLoader from '../../ButtonWithLoader/ButtonWithLoader';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { APIErrorT } from 'shared/models/api';
import { APICallParams, APIInterfaceI } from 'utils/api';

interface ButtonActionDeleteEnforceConfirmProps {
  targetId: string;
  targetName: string;
  api: APIInterfaceI; // From utils/api
  apiCallParams?: APICallParams;
  messageComplement?: string; // Ex: `the flow named '${flowData.name}`
  redirectLocation: string; // Ex: /schc-templates
}

function ButtonActionDeleteEnforceConfirm({
  targetId,
  targetName,
  api,
  apiCallParams,
  messageComplement,
  redirectLocation,
}: ButtonActionDeleteEnforceConfirmProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const history = useHistory();

  const onDelete = () => {
    setIsDeleting(true);
    const inputName = (window.prompt(`Are you sure you want to permanently delete ${messageComplement || 'this item'} ?\nPlease type the following to confirm: ${targetName}`));
    if (inputName && inputName.trim() === targetName) {
      api.delete(targetId, apiCallParams)
        .then((resp: any) => {
          if (resp.status >= 400) {
            resp.json()
              .then((error: APIErrorT) => {
                toast.error(error?.message);
              });
            setIsDeleting(false);
          } else {
            setIsDeleting(false);
            toast.success('Successfully deleted');
            history.push(redirectLocation);
          }
        });
    } else {
      setIsDeleting(false);
      toast.error('Incorrect input, the item is not deleted');
    }
  };

  return (
    <ButtonWithLoader
      variant="contained"
      color="primary"
      onClick={onDelete}
      label="Delete"
      isLoading={isDeleting}
    />
  );
}

export default ButtonActionDeleteEnforceConfirm;
